import { useEffect, useRef } from "react";

// Interactive route map using Leaflet (loaded via CDN in index.html) + OSM tiles. No API key.
export default function RouteMap({ waypoints = [], polyline = [] }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    const L = window.L;
    if (!L || !elRef.current) return;
    if (!mapRef.current) {
      mapRef.current = L.map(elRef.current, { scrollWheelZoom: false, attributionControl: true });
      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 18,
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(mapRef.current);
    }
    const map = mapRef.current;
    if (layerRef.current) {
      map.removeLayer(layerRef.current);
      layerRef.current = null;
    }
    const group = L.featureGroup();
    const pts = waypoints.filter((w) => w.lat != null && w.lng != null);
    pts.forEach((w, i) => {
      const isEnd = i === 0 || i === pts.length - 1;
      L.marker([w.lat, w.lng], {
        title: w.name,
      })
        .bindPopup(`<b>${w.name}</b>`)
        .addTo(group);
    });
    if (polyline && polyline.length >= 2) {
      L.polyline(polyline, { color: "#C4643B", weight: 4, opacity: 0.85, dashArray: "6 8" }).addTo(group);
    }
    if (pts.length) {
      group.addTo(map);
      layerRef.current = group;
      try {
        map.fitBounds(group.getBounds().pad(0.25));
      } catch (e) {
        map.setView([pts[0].lat, pts[0].lng], 5);
      }
    } else {
      map.setView([24.5, -95], 4);
    }
    setTimeout(() => map.invalidateSize(), 150);
  }, [waypoints, polyline]);

  return (
    <div
      ref={elRef}
      data-testid="route-map"
      className="h-72 w-full rounded-xl overflow-hidden border border-sand-200 z-0"
    />
  );
}
